import React from 'react';
import './home.css';
import coin from '../../assets/coin.png'
import raffle from '../../assets/jpass_raffle.png'
import { ConnectWallet } from '../../components/wallet/ConnectWallet';
import useRaffleState from '../../sharedState';
import shallow from 'zustand/shallow';


const Home = () => {
  const {networkError} = useRaffleState((state) => ({networkError: state.networkError}), shallow);
  const {transactionError} = useRaffleState((state) => ({transactionError: state.transactionError}), shallow);
  return (
    <div className='header section__padding'>
      <div className="header-content">
        <div>
          <h1>Join the raffle to get a chance of attending the exclusive event at Julius Bär</h1>
          <img className='shake-vertical' src={coin} alt="" />
        </div>
      </div>
      <div className="header-slider">
        <p className="display-text">Are you curious about where Web3 is heading? Parrticipate in our raffle and join with some luck our event on the 27th October 2022, 15.00-19.00. We invited some of the most important entrepreneurs and thought leaders in the field to tell us about the future of distributed ledger technology.
        </p>
        <p className="display-text">Participants:</p>
        <p className="display-text">Marcus Dapp, Head of Research of Bitcoin Suisse</p>
        <p className="display-text">Roman Schnider, President of the Tezos Foundation</p>
        <p className="display-text">Dominic Williams, Founder and Chief Scientist of Dfinity</p>
      </div>
      <div className='header-slider'>
        <div className='raffle-text-container' style={{textAlign: "center", marginBottom: "1rem"}}>
            <h2 style={{textAlign: "center"}}>Don't miss out!&nbsp;&nbsp;&nbsp;</h2>
        </div>
        <div className='raffle-text-container' style={{textAlign: "center"}}>
            <img src={raffle} className="raffle-button" />
        </div>
      </div>
      <br />
      <h2 style={{ marginBottom: '1.5rem'}}>Instructions</h2>
<p style={{ marginBottom: '1rem'}}>1. When you never worked with blockchains or digital wallets before, signing up for the raffle can seem a bit daunting. But no worries, just follow the steps below. <b>Do those steps on a desktop to ensure that it works properly.</b></p>
<p style={{ marginBottom: '1rem'}}>2. Download and install <a href="https://metamask.io/faqs/">Metamask</a>. Metamask is a digital wallet, that allows you to set up an account on blockchains. If you don't have a wallet yet, follow the steps when starting Metamask the first time to create one.</p>
<br/>
<p style={{ marginBottom: '1rem'}}>3. Now we have to put money in your wallet. For this, copy the address of your wallet from Metamask and enter it in the <a href="https://faucet.egorfine.com/">Ropsten Faucet</a> to receive some rETH.</p>
<br/>
<p style={{ marginBottom: '1rem'}}>4. We deployed the raffle on Ropsten Ethereum Testnet, so that you don't have to spend money on participating. The wallet is usually set to the Mainnet, hence you have to <a href="https://autofarm.gitbook.io/autofarm-network/how-tos/defi-beginners-guide/switching-networks-on-metamask">switch the network in your wallet</a>.</p>
<br/>
<p style={{ marginBottom: '1rem'}}>5. Now everything is in place. Click on the button below to connect your wallet and then follow the signature process to sign up for the raffle.</p>
<br/>
<p style={{ marginBottom: '1rem'}}>6. We will determine the winners next Monday. Come back to this webpage to see whether you have won.</p>
<br/>
<p style={{ marginBottom: '1rem'}}>If you want to take a look at the raffle and the mechanism how we determine the winners, check out the <a href="">smart contract on Etherscan</a>.</p>
<br/>

      <br/><br/>
      <div>
        <h2 className='raffle-text'>{transactionError}</h2>
      </div>
      <div className='raffle-text-container'>
        <ConnectWallet/>
      </div>
    </div>
  );
};

export default Home;
